/* eslint-disable no-useless-escape */
export const splitFile = (fullPath: string) => {
  const dxf_name = fullPath.replace(/^.*[\\\/]/, "");
  const path = fullPath.replace(dxf_name, "");
  return { dxf_name, path };
};
